export const socialEN = {
  phoneNumber: 'Phone number',
  email: 'Email',
  madeWith: 'Made with',
  and: 'and'
};

export const socialES = {
  phoneNumber: 'Numero telefonico',
  email: 'Correo electronico',
  madeWith: 'Hecho con',
  and: 'Y'
};

export const socialIcons = [
  {
    id: 1,
    isClass: 'fa-twitter',
    link: 'https://twitter.com/J4ASDEV'
  },
  {
    id: 2,
    isClass: 'fa-linkedin',
    link: 'https://www.linkedin.com/in/AraujoJonathan/'
  },
  {
    id: 3,
    isClass: 'fa-telegram',
    link: 'https://t.me/j4asdev'
  },
  {
    id: 4,
    isClass: 'fa-github',
    link: 'https://github.com/J4ASDev'
  },
  {
    id: 5,
    isClass: 'fa-medium',
    link: 'https://medium.com/@jonathanaraujo'
  }
];
